import { motion } from "framer-motion";
import { useEffect } from "react";

type Props = {};

const GravityAppPPPage = (props: Props) => {
	useEffect(() => {
		document.title = "Gravity Flip Courier | Privacy Policy";
	}, []);

	return (
		<div className='flex relative overflow-y-scroll overflow-x-hidden gap-y-10 flex-col no-scrollbar items-center justify-center bg-gradient-to-br from-slate-800 via-slate-950 to-slate-800'>
			<motion.div
				className='max-w-4xl mx-auto p-6 bg-slate-800 shadow-md rounded-md my-8 text-slate-100'
				initial={{ opacity: 0, y: 50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8, ease: "easeOut" }}>
				<motion.h1
					className='text-3xl font-bold mb-4'
					initial={{ opacity: 0, y: -20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ delay: 0.2 }}>
					Privacy Policy — Gravity Flip Courier
				</motion.h1>

				<motion.div
					className='text-slate-200 font-semibold text-lg mb-8 space-y-1'
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ delay: 0.4 }}>
					<p>
						<strong>Effective:</strong> July 10, 2026
					</p>
					<p>
						<strong>Developer:</strong> Softwarify
					</p>
					<p>
						<strong>Contact:</strong> sefailyas1455@gmail.com
					</p>
				</motion.div>

				<motion.section className='mb-6' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }}>
					<h2 className='text-2xl font-semibold mb-2'>Data We Collect</h2>
					<ul className='list-disc list-inside text-slate-200 font-semibold text-lg space-y-2'>
						<li>
							<strong>Game data:</strong> Your scores and play statistics are stored with a randomly generated anonymous
							device ID (UUID). This ID is NOT linked to your name, email, or any account.
						</li>
						<li>
							<strong>Advertising data:</strong> Ads are served by Google AdMob, which may collect device identifiers.
							On iOS, if you decline App Tracking Transparency, only non-personalized ads are shown.
						</li>
						{/* <li>
							<strong>Purchase data:</strong> In-app purchases are processed by Apple/Google and RevenueCat; we never
							receive your payment details.
						</li> */}
					</ul>
				</motion.section>

				<motion.section className='mb-6' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.8 }}>
					<h2 className='text-2xl font-semibold mb-2'>How We Use Data</h2>
					<p className='text-slate-200 font-semibold text-lg'>
						Data is used only for gameplay (score saving/backup), serving ads, and verifying purchases. We do not sell
						your data.
					</p>
				</motion.section>

				<motion.section className='mb-6' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.0 }}>
					<h2 className='text-2xl font-semibold mb-2'>Third Parties</h2>
					<ul className='list-disc list-inside text-slate-200 font-semibold text-lg space-y-1'>
						<li>
							Google AdMob — ads (
							<a
								className='underline hover:text-slate-50'
								href='https://policies.google.com/privacy'
								target='_blank'
								rel='noreferrer'>
								policy
							</a>
							)
						</li>
						{/* <li>
							RevenueCat — purchase management (
							<a
								className='underline hover:text-slate-50'
								href='https://www.revenuecat.com/privacy'
								target='_blank'
								rel='noreferrer'>
								policy
							</a>
							)
						</li> */}
						<li>
							Supabase — anonymous score backup (
							<a
								className='underline hover:text-slate-50'
								href='https://supabase.com/privacy'
								target='_blank'
								rel='noreferrer'>
								policy
							</a>
							)
						</li>
					</ul>
				</motion.section>

				<motion.section className='mb-6' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }}>
					<h2 className='text-2xl font-semibold mb-2'>Children</h2>
					<p className='text-slate-200 font-semibold text-lg'>
						The app requires no personal information and does not knowingly collect data from children under 13.
					</p>
				</motion.section>

				<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }}>
					<h2 className='text-2xl font-semibold mb-2'>Data Deletion</h2>
					<p className='text-slate-200 font-semibold text-lg'>
						Uninstalling the app removes all on-device data. Contact us by email (sio@softwarify.co) to request deletion
						of anonymous server-side score records.
					</p>
				</motion.section>
			</motion.div>
		</div>
	);
};

export default GravityAppPPPage;
